module.exports = __webpack_public_path__ + "img/explode.309567cf.png";